module.exports = __webpack_public_path__ + "img/CXMT.ac021a14.jpg";